export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function formatPackageTitle(string: string) {
  return string.toLowerCase() === 'npm' ? string.toLowerCase() : capitalizeFirstLetter(string)
}
